(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@fiverr-private/theme"), require("classnames"), require("lodash"), require("react"), require("react-dom"));
	else if(typeof define === 'function' && define.amd)
		define(["@fiverr-private/theme", "classnames", "lodash", "react", "react-dom"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("@fiverr-private/theme"), require("classnames"), require("lodash"), require("react"), require("react-dom")) : factory(root["theme"], root["classNames"], root["_"], root["React17"], root["ReactDOM17"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(self, (__WEBPACK_EXTERNAL_MODULE_Jt0T__, __WEBPACK_EXTERNAL_MODULE_IX_1__, __WEBPACK_EXTERNAL_MODULE_luq0__, __WEBPACK_EXTERNAL_MODULE_yHGu__, __WEBPACK_EXTERNAL_MODULE__4LQx__) => {
return 